var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleCircleDottedline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6763 4.66667C12.6763 5.03486 12.3736 5.33333 12.0002 5.33333C11.6268 5.33333 11.3241 5.03486 11.3241 4.66667C11.3241 4.29848 11.6268 4 12.0002 4C12.3736 4 12.6763 4.29848 12.6763 4.66667Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1791 5.33688C15.0514 5.68287 14.6634 5.86126 14.3125 5.73533C13.9616 5.6094 13.7807 5.22684 13.9084 4.88086C14.0361 4.53487 14.4241 4.35648 14.775 4.48241C15.1259 4.60834 15.3068 4.9909 15.1791 5.33688Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3459 6.89295C16.6319 7.12962 17.0583 7.09283 17.2984 6.81078C17.5384 6.52873 17.5011 6.10823 17.215 5.87156C16.929 5.63489 16.5025 5.67168 16.2625 5.95373C16.0225 6.23578 16.0598 6.65628 16.3459 6.89295Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7787 8.91072C18.4553 9.09482 18.0418 8.98557 17.8551 8.66671C17.6684 8.34784 17.7792 7.94012 18.1026 7.75602C18.4259 7.57193 18.8394 7.68118 19.0261 8.00004C19.2128 8.3189 19.102 8.72663 18.7787 8.91072Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.658 10.8423C18.7228 11.2049 19.0735 11.447 19.4412 11.3831C19.8089 11.3192 20.0545 10.9734 19.9896 10.6108C19.9248 10.2482 19.5741 10.0061 19.2064 10.07C18.8387 10.134 18.5931 10.4797 18.658 10.8423Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2063 13.9301C18.8386 13.8661 18.5931 13.5204 18.6579 13.1578C18.7227 12.7952 19.0734 12.553 19.4411 12.617C19.8088 12.6809 20.0544 13.0267 19.9895 13.3893C19.9247 13.7519 19.574 13.994 19.2063 13.9301Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8548 15.3332C17.6681 15.6521 17.7789 16.0598 18.1022 16.2439C18.4256 16.428 18.8391 16.3187 19.0258 15.9999C19.2125 15.681 19.1017 15.2733 18.7783 15.0892C18.455 14.9051 18.0415 15.0143 17.8548 15.3332Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.262 18.0462C16.022 17.7642 16.0593 17.3437 16.3453 17.107C16.6313 16.8703 17.0578 16.9071 17.2978 17.1892C17.5378 17.4712 17.5005 17.8917 17.2145 18.1284C16.9284 18.3651 16.502 18.3283 16.262 18.0462Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3122 18.2646C13.9613 18.3906 13.7804 18.7731 13.9081 19.1191C14.0358 19.4651 14.4238 19.6435 14.7747 19.5176C15.1255 19.3916 15.3064 19.0091 15.1787 18.6631C15.051 18.3171 14.6631 18.1387 14.3122 18.2646Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3237 19.3333C11.3237 18.9651 11.6264 18.6667 11.9998 18.6667C12.3732 18.6667 12.6759 18.9651 12.6759 19.3333C12.6759 19.7015 12.3732 20 11.9998 20C11.6264 20 11.3237 19.7015 11.3237 19.3333Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68748 18.2647C9.33661 18.1387 8.94864 18.3171 8.82093 18.6631C8.69323 19.0091 8.87414 19.3917 9.22501 19.5176C9.57589 19.6435 9.96385 19.4651 10.0916 19.1191C10.2193 18.7732 10.0384 18.3906 9.68748 18.2647Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70164 17.1892C6.94165 16.9072 7.3681 16.8704 7.65413 17.107C7.94017 17.3437 7.97747 17.7642 7.73746 18.0463C7.49745 18.3283 7.07101 18.3651 6.78497 18.1284C6.49894 17.8918 6.46163 17.4713 6.70164 17.1892Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1449 15.3335C5.9582 15.0146 5.54472 14.9053 5.22135 15.0894C4.89798 15.2735 4.78719 15.6813 4.97388 16.0001C5.16058 16.319 5.57407 16.4282 5.89744 16.2441C6.2208 16.06 6.3316 15.6523 6.1449 15.3335Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5588 12.6169C4.92652 12.553 5.27718 12.7951 5.34201 13.1577C5.40685 13.5203 5.16132 13.866 4.7936 13.93C4.42588 13.9939 4.07522 13.7518 4.01038 13.3892C3.94555 13.0266 4.19108 12.6808 4.5588 12.6169Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3421 10.8422C5.40694 10.4796 5.16141 10.1339 4.79369 10.0699C4.42597 10.006 4.07531 10.2481 4.01047 10.6107C3.94563 10.9733 4.19117 11.3191 4.55888 11.383C4.9266 11.447 5.27726 11.2048 5.3421 10.8422Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89777 7.75611C6.22113 7.9402 6.33193 8.34793 6.14523 8.66679C5.95853 8.98565 5.54505 9.0949 5.22168 8.91081C4.89831 8.72671 4.78752 8.31899 4.97421 8.00012C5.16091 7.68126 5.5744 7.57201 5.89777 7.75611Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6547 6.893C7.94073 6.65633 7.97804 6.23583 7.73803 5.95378C7.49802 5.67173 7.07157 5.63494 6.78554 5.87161C6.4995 6.10827 6.46219 6.52878 6.70221 6.81083C6.94222 7.09288 7.36866 7.12967 7.6547 6.893Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0919 4.88088C10.2196 5.22687 10.0387 5.60943 9.68781 5.73536C9.33693 5.86129 8.94896 5.6829 8.82126 5.33691C8.69355 4.99093 8.87446 4.60836 9.22534 4.48244C9.57621 4.35651 9.96418 4.5349 10.0919 4.88088Z",
    fill: "currentColor",
    fillOpacity: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.006 7.33333C9.39228 7.33333 7.27342 9.42267 7.27342 12C7.27342 14.5773 9.39228 16.6667 12.006 16.6667C14.6198 16.6667 16.7386 14.5773 16.7386 12C16.7386 9.42267 14.6198 7.33333 12.006 7.33333ZM8.62559 12C8.62559 10.1591 10.1391 8.66667 12.006 8.66667C13.873 8.66667 15.3865 10.1591 15.3865 12C15.3865 13.841 13.873 15.3333 12.006 15.3333C10.1391 15.3333 8.62559 13.841 8.62559 12Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircleDottedline);
export default __webpack_public_path__ + "static/media/double-circle-dottedline.c7b905657d1755d8fe9bdae1f0080610.svg";
export { ForwardRef as ReactComponent };